import { render, staticRenderFns } from "./viewFileSimplify.vue?vue&type=template&id=66d01505"
import script from "./viewFileSimplify.vue?vue&type=script&lang=js"
export * from "./viewFileSimplify.vue?vue&type=script&lang=js"
import style0 from "./viewFileSimplify.vue?vue&type=style&index=0&id=66d01505&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports